import { FC, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import { TicketContext } from '../../contexts/TicketContext';
import { parseDutchPhoneNumber } from '../../helpers/Phone';
import { TicketRoutePaths } from '../../interfaces/Routes';
import StepsService from '../../services/StepsService';
import MaterialIcon from '../MaterialIcon/MaterialIcon';
import SmallActionContainer, { Action } from '../SmallActionContainer/SmallActionContainer';
import style from './SmallFAQCallContainer.module.scss';

interface SmallFAQCallContainerProps {
  fullRowWidth?: boolean;
  mobileOnly?: boolean;
  renderFAQ?: boolean;
  renderPhone?: boolean;
}

const GUIDION_NAME = 'Guidion';

export const SmallFAQCallContainer: FC<SmallFAQCallContainerProps> = ({
  renderFAQ, renderPhone, fullRowWidth, mobileOnly
}) => {
  const { ticket } = useContext(TicketContext);
  const { stylesheet: { contact, settings: { partnerName }, } } = useContext(StylesheetContext);
  const { serviceDeskNumber, onlyMentionPartnerInFooter } = contact;

  const { t } = useTranslation();

  const actions = useMemo(() => {
    const actions: Action[] = [];

    if (renderFAQ !== false) {
      actions.push({
        icon: <MaterialIcon name="event_note" size={24} />,
        header: <Link to={StepsService.getStepUri(ticket?.hashId, TicketRoutePaths.contact)}>
          {t('contact:contactPageLink')}
        </Link>,
        content: <span>{t('contact:contactPageLinkDescription')}</span>,
        alt: t('contact:contactPageLink'),
      });
    }

    if (renderPhone !== false){
      const parsedPhoneNumber = parseDutchPhoneNumber(serviceDeskNumber);

      actions.push({
        icon: <MaterialIcon className={style.callIcon} name="phone" size={24} />,
        header: <span>{t('footer:call', { partner: onlyMentionPartnerInFooter ? partnerName : GUIDION_NAME })}</span>,
        content: <a href={`tel:${serviceDeskNumber}`}>
          {parsedPhoneNumber} ({t('contact:localTariff')})
        </a>,
        alt: t('contact:localTariff'),
      });
    }

    return actions;
  }, [renderFAQ, renderPhone, ticket?.hashId, t, onlyMentionPartnerInFooter, partnerName, serviceDeskNumber]);

  return (
    <SmallActionContainer
      actions={actions}
      mobileOnly={mobileOnly}
      wide={fullRowWidth}/>
  );

};
